"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('ui/main',["require", "exports", "text!./main.html", "jquery", "services/authenticationService", "scriptLoaders/bundleLoader", "models/userIdentityModel", "knockout", "helpers/accessTokenHelper", "store/tokenStore", "services/tokenService", "context"], function (require, exports, templateMarkup, jquery, authenticationService, bundleLoader, userIdentityModel, ko, accessTokeHelper, tokenStore, tokenService, context) {
    "use strict";
    /// <amd-dependency path='text!./main.html' name='templateMarkup' />

    var Main = function () {
        function Main() {
            _classCallCheck(this, Main);

            this.shellName = ko.observable();
            if (tokenStore.getAccessToken()) {
                this.getManageInfo().done(this.getManageInfoSuccess.bind(this)).fail(this.getManageInfoFailed.bind(this));
            } else {
                this.getManageInfoFailed({ status: 404 });
            }
        }

        _createClass(Main, [{
            key: "getManageInfoSuccess",
            value: function getManageInfoSuccess(manageInfoResponse) {
                var _this = this;

                context.hereMapsApiKey = manageInfoResponse.hereMapsApiKey;
                context.appBundleUrl = manageInfoResponse.appBundleUrl;
                bundleLoader.loadBundleAsyncOnce().done(function () {
                    require(['app/startup'], function () {
                        userIdentityModel.setSessionId(manageInfoResponse.sessionId);
                        userIdentityModel.claims(manageInfoResponse.claims);
                        userIdentityModel.setUserName(manageInfoResponse.email);
                        userIdentityModel.setLocalLoginProvider(manageInfoResponse.localLoginProvider);
                        userIdentityModel.setTwoFactorEnabled(manageInfoResponse.twoFactorEnabled);
                        userIdentityModel.setInsurerId();
                        tokenStore.setAccessTokenExpiresIn(manageInfoResponse.accessTokenExpiresIn);
                        accessTokeHelper.setRefreshTimeout();
                        userIdentityModel.isAuthenticated(true);
                        _this.shellName('shell');
                    });
                });
            }
        }, {
            key: "getManageInfoFailed",
            value: function getManageInfoFailed(err) {
                var _this2 = this;

                if (err.status === 401 && tokenStore.getRefreshToken()) {
                    tokenService.refreshToken().done(function (result) {
                        tokenStore.setAccessToken(result.accessToken, result.refreshToken, result.accessTokenExpiresIn);
                        _this2.getManageInfo().done(_this2.getManageInfoSuccess.bind(_this2)).fail(_this2.getManageInfoFailed.bind(_this2));
                    }).fail(function () {
                        userIdentityModel.isAuthenticated(false);
                        _this2.shellName('shell');
                    });
                } else {
                    userIdentityModel.isAuthenticated(false);
                    this.shellName('shell');
                }
            }
        }, {
            key: "getManageInfo",
            value: function getManageInfo() {
                var deferred = jquery.Deferred();
                authenticationService.getManageInfo().done(function (manageInfoResponse) {
                    deferred.resolve(manageInfoResponse);
                }).fail(function (err) {
                    deferred.reject(err);
                });
                return deferred.promise();
            }
        }]);

        return Main;
    }();

    return { viewModel: Main, template: templateMarkup };
});
//# sourceMappingURL=main.js.map;
